// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/get-integration-calls-request-schema',
  type: 'object',
  required: [],
  properties: {
    dateFrom: {
      type: 'string',
      format: 'date-time',
    },
    dateTo: {
      type: 'string',
      format: 'date-time',
    },
    integrationTaskId: {
      type: 'integer',
    },
    integrationStatusId: {
      type: 'integer',
    },
    correlationId: {
      type: 'string',
    },
    appTransactionId: {
      type: 'string',
    },
    appUserId: {
      type: 'integer',
    },
    searchCriteria: {
      type: 'string',
    },
    'paging.CurrentPage': {
      type: 'integer',
    },
    'paging.PageSize': {
      type: 'integer',
    },
    'paging.IncludeCount': {
      type: 'boolean',
    },
    'paging.NoPaging': {
      type: 'boolean',
    },
  },
} as IJSONSchema;

export default schema;
